var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"pa-4",attrs:{"cols":"auto"}},[_c('span',{staticStyle:{"text-align":"left"},domProps:{"innerHTML":_vm._s(_vm.parsedInfoContent)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }